module.exports = __webpack_public_path__ + "static/media/2_pl.8d78f1b1.png";